
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component<InputModalContainer>({})

export default class InputModalContainer extends Vue {
	@Prop({ type: String, required: true, default: '' }) private title!: string;
}
